export default class Uebergaben{

    ubergabenList : any;


    constructor() {
        this.ubergabenList = this.getAll();
    }


    getAll() {
        const arr = [
            {
                header: 'Übergabe Carraro TTR 7800',
                text: "Familie Ilg mit Ihrem neuen Carraro TTR 7800 , 71 PS, für die Landwirtschaft und als\n" +
                    "\n" +
                    "Allroundmaschine das ganze Jahr hindurch. Besten Dank.",
                image: "fam_ilg.jpg"
            },
            {
                header: 'Übergabe Carraro TTR 7600',
                text: "Josef Spettel aus Andelsbuch erhält für seine Landwirtschaft\n" +
                    "\n" +
                    "einen neuen Carraro TTR 7600 Infinity 75 PS mit stufenlosem Fahrantrieb,\n" +
                    "\n" +
                    "Kabine, Heizung, Klimaanlage, usw. – wir wünschen gute Fahrt.",
                image: "spettel_josef.jpg"
            },
            {
                header: 'Übergabe SILOKING Futtermischwagen',
                text: "Andreas Tschann aus Thüringen ist nun stolzer Besitzer eines neuen\n" +
                    "SILOKING Futtermischwagen mit 10 m3, Turboschnecke, Förderband hinten,\n" +
                    "Untersetzungsgetriebe und Wiegeeinrichtung - Mahlzeit -",
                image: "fam_tschann.jpg"
            },
            {
                header: 'Übergabe Claas Teleskoplader',
                text: "Drei Generationen der Familie Fink, Landesprodukte aus Höchst übernehmen\n" +
                    "einen\n" +
                    "neuen Claas Teleskoplader Scorpion 736 Vario Power.\n" +
                    "Sonja Fink mit Nachwuchs und Christoph sowie Wolfgang Fink freuen sich über\n" +
                    "den\n" +
                    "136 PS starken Lader mit 7 m Hubhöhe und 3,60 to. Hubkraft.",
                image: "fam_fink.jpg"
            },
            {
                header: 'Übergabe Claas Arion 450 A',
                text: "Marte Karlheinz und Alexander aus Röthis übernehmen ihren neuen Claas Arion\n" +
                    "450 A\n" +
                    "Der 135 PS starke Arion hat neben Hexashift 6-fach Lastschaltung, gefederte\n" +
                    "Vorderachse,\n" +
                    "gefederte Kabine, Fronthydraulik und Frontzapfwelle und Druckluftanlage so\n" +
                    "ziemlich\n" +
                    "alles zu bieten. Die Mehele Landtechnik wünscht gute Fahrt mit dem neuen\n" +
                    "Arion 450.",
                image: "marte_arion.jpg"
            },
            {
                header: 'Übergabe Claas Elios 210',
                text: "Gunz Elmar aus Bildstein übernimmt einen neuen Claas Elios 210 Allrad" +
                    "\n" +
                    "Der 75 PS starke 4 Zylinder Kompakttraktor wird für Allroundarbeiten eingesetzt." +
                    "\n" +
                    "Wir wünschen viel Freude und bedanken uns bei Elmar.",
                image: "gunz_elmar.jpg"
            },
            {
                header: 'Übergabe Claas Teleskoplader 756',
                text: "Firma Hilbe Nahwärme OG aus Dornbirn übernimmt einen neuen CLAAS Teleskoplader Scorpion 756 Varipower.\n" +
                    "\n" +
                    "Der 156 PS (Deutz) starke Telelader mit 7,0 m Hubhöhe und 5,60 Tonnen Hubkraft, bewegt mit einer\n" +
                    "\n" +
                    "5,0 m3 Großvolumenschaufel, rund 20.000 m3 Hackschnitzel pro Jahr am Lagerplatz in Dornbirn.",
                image: "hilbe_og.jpg"
            },
            {
                header: 'Übergabe Claas Arion 450',
                text: "Vor kurzem holte Türtscher Elmar aus Höchst seinen neuen Claas Arion 450 ab.\n" +
                    "\n" +
                    "Der Arion leistet 135 PS und wurde mit Fronthydraulik, Frontzapfwelle,\n" +
                    "\n" +
                    "gefederter Vorderachse, gefederter Kabine, Druckluftanlage,\n" +
                    "\n" +
                    "Hexashift 6-fach Lastschaltgetriebe und vieles mehr an Elmar übergeben.\n" +
                    "\n" +
                    "Das Mehele Team dankt für den Auftrag.",
                image: "tuertscher_elmar.jpg"
            },
            {
                header: '3 Manitou Telelader zur Auslieferung bereit',
                text: "Kurz vor der Auslieferung an unsere Kunden stehen 3 Manitou Teleskoplader MLT 420 - H60\n" +
                    "\n" +
                    "Die kompakten 57 PS Lader mit einer Bauhöhe von unter 2 m und einer Breite von 1,50 m heben\n" +
                    "\n" +
                    "2,0 Tonnen bei einer Hubhöhe von 4,35 m und einem Eigengewicht von 4,0 t.\n" +
                    "\n" +
                    "Die sehr geräumige Kabine und feinfühlige Joystickbedienung überzeugten die Kunden  ebenfalls.\n" +
                    "\n" +
                    "Als Arbeitswerkzeuge kommen Schaufel, Palettengabel, Rundballenzange und Krokogebiß zum Einsatz.\n" +
                    "\n" +
                    "Wir danken unseren Kunden und wünschen frohes Werken.",
                image: "manitou_telelader.jpg"
            },
            {
                header: 'Übergabe Schiltrac Transporter Swisstrans',
                text: "Greber Herbert und Sohn übernehmen einen Schiltrac Transporter Swisstrans\n" +
                    "6150 mit 175 PS Deutz 6-Zylinder Motor\n" +
                    "mit allen Raffinessen. Front, Vierrad- und Hundeganglenkung\n" +
                    "inclusive.Zwillingsbereifung hinten und vorne.\n" +
                    "Aufgebaut ist ein Lüönd Elite S Ladewagen mit 39 m3. Dazu kommt noch ein\n" +
                    "Güllefass und Aufbaustreuer.\n" +
                    "Der Schiltrac wird auch überbetrieblich eingesetzt. Wir wünschen gute Fahrt.",
                image: "greber_herbert_und_sohn.jpg"
            },
            {
                header: 'Übergabe Carraro TTR 7600 Infinity',
                text: "Müller Rene und Vater Wilfried aus Raggal-Marul vor Ihrem neuen Carraro TTR 7600 Infinity\n" +
                    "\n" +
                    "75 PS mit stufenlosem Fahrantrieb, Kabine Heizung, Klima, Knüsel Bandheuer, Hecklader,\n" +
                    "\n" +
                    "Besten Dank und gute Fahrt .",
                image: "mueller_wilfried_rene.jpg"
            },
            {
                header: 'Übergabe Kuhn Kreiselheuer',
                text: "Heeb Julian aus Feldkirch freut sich über seinen neuen Kuhn Kreiselheuer GF\n" +
                    "8712 T \n" +
                    "mit 8,70 m Arbeitsbreite, Transportfahrwerk, 8 Kreisel, Doppeltastrad vorne,\n" +
                    "und Vorgewendeaushub. Danke für den Auftrag.",
                image: "heeb_julian.jpg"
            },
            {
                header: 'Übergabe Carraro TTR 7600',
                text: "Voller Stolz übernimmt Klaus Bruggmüller aus Gaschurn seinen neuer Carraro TTR 7600 Infinity 75 PS mit stufenlosem Fahrantrieb,\n" +
                    "\n" +
                    "Kabine , Heizung, Klima, Knüsel Mähwerk 260 und Knüsel Bandheuer 245/5. Der Carraro wird für Heuarbeiten und als\n" +
                    "\n" +
                    "Allroundmaschine das ganze Jahr hindurch eingesetzt. Danke an Klaus für den Auftrag.",
                image: "bruggmueller_klaus.jpg"
            },
            {
                header: 'Übergabe Rapid Motormäher',
                text: "Endlich leichter Arbeiten dachte sich Wachter Johannes aus Bartholomäberg,\n" +
                    "als er einen von\n" +
                    "vielen ausgelieferten Rapid Motormähern entgegennahm, Johannes entschied\n" +
                    "sich für einen\n" +
                    "Rapid Monta mit 16 PS, Zero-Turn Lenkung, Stachelwalzen, Doppelmessermähwerk\n" +
                    "2,07 m und einen\n" +
                    "Rapid Multi-Twister 190 cm mit Förderband.\n" +
                    "Wir wünschen Johannes viel Freude mit dem neuen Gespann.",
                image: "wachter_johannes.jpg"
            },
            {
                header: 'Übergabe Claas Arion 400',
                text: "Kohler Bertram und Stefan aus Mellau erhalten einen Claas Arion 400 mit 105 PS,\n" +
                    "\n" +
                    "Kabine mit Klima, Kabinen-  und Vorderachsfederung, Multifunktionsgriff,\n" +
                    "\n" +
                    "Quadrishift 4-fach Lastschaltgetriebe, Druckluftanlage, Fronthydraulik uvm.\n" +
                    "\n" +
                    "Wir danken der Fam. Kohler für den Auftrag.",
                image: "kohler_bertram.jpg"
            },
            {
                header: 'Übergabe RIGI TRAC SKH 75',
                text: "Viel Grund zur Freude hatten Feurle Johann aus Langen b.B. mit Sohn Martin und Johannes bei der Übernahme Ihres\n" +
                    "\n" +
                    "neuen RIGI TRAC SKH 75, mit 110 PS Deutz Motor, stufenlosem Fahrantrieb und 3 Lenkungsarten, Zwillingbereifung hinten und vorne,\n" +
                    "\n" +
                    "Fronthydraulik + Frontzapfwelle und hydraulische Geräteentlastung. Die Hightech Maschine mit zentralem Drehgelenk\n" +
                    "\n" +
                    "bietet beste Bodenanpassung und ist an Wendigkeit und Hangtauglichkeit nicht zu überbieten.\n" +
                    "\n" +
                    "Der RIGITRAC wird für Heuarbeiten, zum Eingrasen am steilen Hang, und Zugarbeiten verwendet.\n" +
                    "\n" +
                    "Wir wünschen der Familie Feurle viel Freude bei der Arbeit – Danke.",
                image: "feuerle_johann_und_sohn.jpg"
            },
            {
                header: 'Übergabe Claas Arion 410',
                text: "Bischof Bruno, Sohn Lukas und Tochter Kerstin holen Ihren neuen Claas Arion 410 CIS 90 PS 4-Zylindermotor ab.\n" +
                    "\n" +
                    "Quadrishift 4-fach Lastschaltung, Druckluftanlage, Fronthydraulik und Frontzapfwelle, hohe Hydraulikleistung,\n" +
                    "\n" +
                    "Panoramic-Kabine, ideal für Frontladerbetrieb, sind nur ein Teil der Top ausgestatten Maschine.\n" +
                    "\n" +
                    "Das Team von Mehele Landtechnik sagt Danke und wünscht gute Fahrt.",
                image: "bischof_bruno_lukas_kerstin.jpg"
            },
            {
                header: 'Übergabe Kuhn Kreiselheuer GF 10812 T',
                text: "Streubild vom Feinsten, dieser Überzeugung ist Mätzler Alexander aus Rankweil,\n" +
                    "\n" +
                    "der den ersten Schnitt mit seinem neuen Kuhn Kreiselheuer GF 10812 T\n" +
                    "\n" +
                    "mit 10,80 m Arbeitsbreite und Transportfahrwerk gemacht hat.",
                image: "maetzler_alexander.jpg"
            },
            {
                header: 'Übergabe Claas Doppelseitenmähwerk DISCO 9200',
                text: "Hofer Reinhard und Söhne übernehmen ein Claas Doppelseitenmähwerk DISCO 9200 mit\n" +
                    "\n" +
                    "9,20 m Arbeitsbreite, MaxCut Mähbalken und integrierter hydraulischen Entlastung,\n" +
                    "\n" +
                    "für mehr Schlagkraft auf Ihrem Betrieb. Wir Danken den Hofers für den Kauf.",
                image: "hofer_reinhard_und_soehne.jpg"
            },
            {
                header: 'Übergabe Carraro Mähtrac TTR 7600 Infinity',
                text: "Domig Stefan aus Lingenau erhält einen Carraro Mähtrac TTR 7600 Infinity 75 PS mit stufenlosem Fahrantrieb,\n" +
                    "\n" +
                    "Kabine mit Heizung und Klima, große 17 Zoll Räder, Scheibenmähwerk 260 und Bandheuer 250/5,\n" +
                    "\n" +
                    "Stefan verwendet den einfach zu fahrenden TTR für seine Heuarbeiten und als Zweittraktor\n" +
                    "\n" +
                    "für allerhand Arbeiten auf seinem Betrieb. Wir danken Stefan für die Anschaffung und wünschen alles Gute.",
                image: "domig_stefan.jpg"
            },
            {
                header: 'Übergabe Claas Arion 450',
                text: "Gmeiner Benedikt aus Sulzberg übernimmt einen Claas Arion 450 mit 130 PS, Kabine mit Panoramadach und Klimaanlage,\n" +
                    "\n" +
                    "gefederte Vorderachse, Kabinenfederung, Druckluftanlage, Hexashift Getriebe mit 6-fach Lastschaltung,\n" +
                    "\n" +
                    "Fronthydraulik + Frontzapfwelle, Frontlader und Schaufel,\n" +
                    "\n" +
                    "sowie einen Kuhn Kreiselheuer GF 10812 mit 10,80 m Arbeitsbreite auf 3-Punktanbau.\n" +
                    "\n" +
                    "Wir danken Benedikt , dass er sich für diese zwei starken Marken entschieden hat\n" +
                    "\n" +
                    "und wünschen frohes Werken.",
                image: "gmeiner_benedikt.jpg"
            },
            {
                header: 'Übergabe Carraro TTR 7800',
                text: "Amann Peter aus Hohenems – Reute übernimmt einen neuen Carraro TTR 7800 mit 71 PS 4-Zylindermotor,\n" +
                    "\n" +
                    "Kabine mit Heizung und Klimaanlage, Front und Heckhydraulik, große Terraräder,\n" +
                    "\n" +
                    "Peter verwendet den Carraro als Allroundmaschine mit enormer Hubkraft für Staplerarbeiten,\n" +
                    "\n" +
                    "Mulcharbeiten, Waldarbeit und Schneeräumung  – denn keiner ist vielseitiger.\n" +
                    "\n" +
                    "Wir wünschen Peter viel Spass mit dem neuen Carraro.",
                image: "amann_peter.jpg"
            },
            {
                header: 'Übergabe Kuhn Kreiselheuer GF 10812 T',
                text: "Waibel Ernst aus Götzis übernimmt einen Kuhn Kreiselheuer GF 10812 T mit Transportfahrwerk,\n" +
                    "\n" +
                    "10,80 m Arbeitsbreite, 10 Kreisel, Doppeltastrad vorne, hydraulische Grenzstreueinrichtung\n" +
                    "\n" +
                    "und Vorgewendeaushub. Wir danken Ernst , dass er sich für dieses Topmodell von KUHN\n" +
                    "\n" +
                    "entschieden hat.",
                image: "waibel_ernst.jpg"
            },
            {
                header: 'Übergabe Claas Mittelschwader Liner 2800',
                text: "Spiegel Michael und Söhne aus Dornbirn übernehmen einen Claas Mittelschwader Liner 2800 " +
                    "Arbeitsbreite 7,40 m – 8,20 m Arbeitsbreite hydraulisch verstellbar, 6-Radfahrwerk für optimale Bodenanpassung. " +
                    "Bestes Futter für Feinschmecker. Danke für den Auftrag.",
                image: "spiegel_und_soehne.jpg"
            },
            {
                header: 'Übergabe Claas Arion 400 mit 105 PS',
                text: "Sohm Walter u. Christian aus Dünserberg erhalten eine Claas Arion 400 mit 105 PS, " +
                    "Niedrigdach mit 2,54 m, 4 fach Lastschaltung, Fronthydraulik, Frontzapfwelle, Druckluftanlage," +
                    "Hauer Frontlader mit Arbeitsgeräten, Wir wünschen allzeit gute Fahrt",
                image: "sohm_walter_christian.jpg"
            },
            {
                header: 'Übergabe Antonio Carraro Wendetrac TTR 10900 R',
                text: "David Reheis und Muxel Hubert aus Egg-Großdorf erhalten einen neuen Antonio Carraro Wendetrac TTR 10900 R mit 100 PS Motor, große Terraräder,Kabine , Heizung, Klimaanlage, Front und Heckhydraulik.\n" +
                    "Nun besitzen Sie 2 Carraro für die Heuarbeit und vieles mehr das ganze Jahr hindurch.\n" +
                    "Wir bedanken uns bei David und Hubert.\n",
                image: "reheis_muxel.jpg"
            },
            {
                header: 'Übergabe Manitou Teleskoplader MLT 840',
                text: "Bischof Thomas, Agrarhandel aus Hohenems erhält einen Manitou Teleskoplader " +
                    "MLT 840 mit  145 PS Motor, Hubhöhe 8 m, Hubkraft 4 to." +
                    "Klimaanlage, 3 Lenkungsarten, hydr. Geräteschnellwechsel." +
                    "Der Lader wird für tägliche Arbeitenrbeiten auf seinem Betrieb verwendet." +
                    "Wir Danken Thomas für sein Vertrauen",
                image: "bischof_thomas.jpg"
            }
            /*{
                header: 'Übergabe an Mähtraktor Marke 1 an Max Mustermann',
                text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt " +
                    "ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo " +
                    "dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. " +
                    "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut " +
                    "labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores " +
                    "et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
                image: "http://placekitten.com/g/200/200"
            },
            {
                header: 'Übergabe an Mähtraktor Marke 2 an Max Musterman2',
                text: "Lorem ipsumsed diam nonumy eirmod tempor invidunt ut " +
                    "labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores " +
                    "et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
                image: "http://placekitten.com/g/200/200"
            }*/
        ];

        return arr;
    }

}
